export default "__VITE_ASSET__a89d333a__"